import { Stack } from "@mui/material";
import { CustomButton } from "./CustomButton";
import { ReuseTooltip } from "./ReuseTooltip";

type Props = {
  currentTab: string;
  onChange: (tab: string) => void;
  tabs: { label: string; isDisabled: boolean; tooltip: string }[];
  fullWidth?: boolean;
};

export const ButtonTabsWithTooltip = ({
  currentTab,
  onChange,
  fullWidth,
  tabs,
}: Props) => {
  return (
    <Stack direction={"row"} gap="8px">
      {tabs.map(({ label, isDisabled, tooltip }) => (
        <ReuseTooltip
          text={isDisabled ? tooltip : ""}
          hideChildren={false}
          style={{ width: fullWidth ? "100%" : undefined }}
          maxWidth={"200px"}
          key={label}
        >
          <CustomButton
            onClick={() => onChange(label)}
            variant="text"
            type="button"
            fullWidth={fullWidth}
            disabled={isDisabled}
            sx={{
              gap: 0,
              textWrap: "nowrap",
              color: `${currentTab === label ? "#1C3C6C" : "#585858"}`,
              cursor: `${currentTab === label ? "auto" : "pointer"}`,
              backgroundColor: `${currentTab === label ? "#E8ECF0" : "#F4F5F8"}`,
              "&:hover": {
                backgroundColor: "#E8ECF0",
              },
              height: "36px",
            }}
            customSize="fit"
          >
            {label}
          </CustomButton>
        </ReuseTooltip>
      ))}
    </Stack>
  );
};
